import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalRequestTigoSaleOrderPageRoutingModule } from './modal-request-tigo-sale-order-routing.module';

import { ModalRequestTigoSaleOrderPage } from './modal-request-tigo-sale-order.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    ModalRequestTigoSaleOrderPageRoutingModule
  ],
  declarations: [ModalRequestTigoSaleOrderPage]
})
export class ModalRequestTigoSaleOrderPageModule {}
